
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"55mm","height":"336","viewBox":"0 0 55 88.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"colorable",attrs:{"d":"M26.591 29.712c-5.034 0-9.088 4.382-9.088 9.825v.983h4.544v-.983c0-2.721 2.027-4.912 4.544-4.912 2.518 0 4.544 2.19 4.544 4.912 0 1.108-.85 3.282-1.738 4.038-4.82 4.102-4.77 3.424-11.894 8.735v6.878H35.68V52.31h-4.544v1.965H22.956c5.626-4.282 6.037-4.179 10.445-8.443 1.412-1.367 2.278-4.079 2.278-6.295 0-5.443-4.053-9.825-9.088-9.825z"}}),_c('g',{staticClass:"fg_background",attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M11.596 7.605c-2.517 0-4.544 2.191-4.544 4.913v.491h2.272v-.491c0-1.361 1.013-2.456 2.272-2.456s2.272 1.095 2.272 2.456c0 .554-.425 1.64-.869 2.018-2.41 2.051-2.385 1.713-5.947 4.368v3.44h9.088v-3.44h-2.272v.983H9.78c2.812-2.142 3.018-2.09 5.222-4.222.706-.683 1.14-2.04 1.14-3.147 0-2.722-2.028-4.913-4.545-4.913zM43.404 81.295c2.517 0 4.544-2.191 4.544-4.913v-.491h-2.272v.491c0 1.36-1.013 2.456-2.272 2.456s-2.272-1.095-2.272-2.456c0-.554.425-1.64.869-2.018 2.41-2.051 2.385-1.713 5.947-4.368v-3.44H38.86v3.44h2.272v-.983H45.22c-2.812 2.141-3.018 2.09-5.222 4.222-.706.683-1.14 2.04-1.14 3.147 0 2.722 2.028 4.913 4.545 4.913z"}})])])
          )
        }
      }
    